import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormServices from "../../services/FormService";
import { notification } from "antd";
/* import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui'; */
import { Survey } from "survey-react";
import "survey-react/survey.css";
import Lodder from "../../components/Lodder";
const GenericForm = () => {
  const navigate = useNavigate();
  const customerServiceId = useParams().customerServiceId;
  const [formDesign, setFormDesign] = useState("");
  const [formData, setFormData] = useState("");
  const [id, setId] = useState(0);
  const [formDesignId, setFormDesignId] = useState(0);
  const [showLodder, setShowLodder] = useState(false);
  useEffect(() => {
    setShowLodder(true);
    FormServices.GetFormDesignByCustomerServiceId(customerServiceId)
      .then((response) => {
        if (response && response.status) {
          setFormDesign(response.resultData.formJson);
          setFormDesignId(response.resultData.id);
          FormServices.GetFormDataByCustomerServiceIdAndFormId(
            customerServiceId,
            response.resultData.id
          )
            .then((response) => {
              debugger
              if (response && response.status && response.resultData !== null) {
                setFormData(JSON.parse(response.resultData.formResponseJson));
                setId(response.resultData.id);
              }
              setShowLodder(false);
            })
            .catch((error) => {
              setShowLodder(false);
              notification.error({
                message: error.response.data.Message,
              });
            });
        }
      })
      .catch((error) => {
        setShowLodder(false);
        notification.error({
          message: error.response.data.Message,
        });
      });
  }, []);
  const handleComplete = (survey, options) => {
    setShowLodder(true);
    const data = {
      id: id,
      formResponseJson: JSON.stringify(survey.data),
      customerServiceId: customerServiceId,
      formDesignId: formDesignId,
    };
    FormServices.AddUpdateFormData(data)
      .then((response) => {
        if (response && response.status) {
          setShowLodder(false);
          notification.success({
            message: "Submitted successfully!",
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        setShowLodder(false);
        notification.error({
          message: error.response.data.Message,
        });
      });
  };
  return (
    <>
      <Lodder show={showLodder} />
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container my-5 pt-3">
            <div className="row mb-4 mx-auto">
              {formDesign !== "" && (
                <Survey
                  json={formDesign}
                  data={formData}
                  onComplete={handleComplete}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GenericForm;
